import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { DxCheckBoxModule, DxTextBoxModule } from 'devextreme-angular';
import { NgIf, AsyncPipe, NgFor } from '@angular/common';
import { cameFromClick } from '@asamco/utils';
import { LoadInvoiceConfig } from '../interfaces/load-invoice-config.interface';

@Component({
    selector: 'load-invoice-config-modal',
    templateUrl: 'loadinvoiceconfigmodal.component.html',
    styleUrls: ['loadinvoiceconfigmodal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: true,
    imports: [
        NgIf,
		NgFor,
        DxCheckBoxModule,
        FormsModule,
        AsyncPipe,
		DxTextBoxModule
    ],
})
export class LoadInvoiceConfigModalComponent {
	@Input()
	ls;

	@Input()
	is;

	@Input()
	cspEnvironment: 'csp'|'cspfs';

	config: LoadInvoiceConfig;

	configReady$: Subject<LoadInvoiceConfig>;

	visible$ = new BehaviorSubject<boolean>(false);

	constructor() {

	}

	onSaveAsMockDataChanged(e) {
		if (cameFromClick(e) && this.ls) {
			this.config.saveAsMockData = e.value;
			if(e.value) {
				this.config.downloadRawData = false;
				this.config.exposeSourceLines = false;
				this.config.anonymizeData = true;
			}
		}
	}

	onAnonymizeDataChanged(e) {
		if (cameFromClick(e) && this.ls) {
			this.config.anonymizeData = e.value;
		}
	}

	onExposeSourceLinesChanged(e) {
		if (cameFromClick(e) && this.ls) {
			this.config.exposeSourceLines = e.value;
			if(e.value) {
				this.config.downloadRawData = false;
				this.config.saveAsMockData = false;
			}
		}
	}

	onDownloadRawDataChanged(e) {
		if (cameFromClick(e) && this.ls) {
			this.config.downloadRawData = e.value;
			if(e.value) {
				this.config.saveAsMockData = false;
				this.config.exposeSourceLines = false;
			}
		}
	}

	showAndAwait(config: LoadInvoiceConfig) {
		this.config = config;
		this.configReady$ = new Subject<LoadInvoiceConfig>();
		this.visible$.next(true);
		return this.configReady$;
	}

	ok(): void {
		this.visible$.next(false);
		this.configReady$.next(this.config);
	}

	hide(): void {
		this.visible$.next(false);
	}
}
